import AddHollow from '@clearkit/icons/glyphs/AddHollow';
import { CKButton } from '@clearkit/react';

import { emptyNode } from '~/components/SearchBuilder/utils/constants';
import {
  insertNode,
  SearchContext,
} from '~/components/SearchBuilder/utils/searchUtils';

import { emptyGroup } from '../../utils/fixtures';
import AndOrDecorator from '../AndOrDecorator';
import styles from './styles';

export class UnwrappedQueryGroup extends React.Component {
  render() {
    const {
      children,
      classes,
      className,
      node,
      canAddGroup = true,
      onChange,
      search,
    } = this.props;

    const { disabled } = this.context;

    return (
      <div className={classnames(className, classes.root)}>
        <div className={classes.queryGroupContents}>
          <AndOrDecorator node={node} search={search} onChange={onChange}>
            {children}
            <div className={classes.queryGroupActions}>
              {!disabled && (
                <>
                  <CKButton
                    leftIcon={<AddHollow />}
                    variantColor="blue"
                    variant="tertiary"
                    isSmall
                    rel="add-condition-button"
                    className={classes.button}
                    disabled={disabled}
                    onClick={() => {
                      const newSearch = insertNode(search, node, emptyNode);
                      onChange(newSearch);
                    }}>
                    Add condition
                  </CKButton>
                  {canAddGroup && (
                    <CKButton
                      leftIcon={<AddHollow />}
                      disabled={disabled}
                      className={classes.button}
                      variant="tertiary"
                      onClick={() => {
                        const newSearch = insertNode(search, node, emptyGroup);
                        onChange(newSearch);
                      }}>
                      Add group
                    </CKButton>
                  )}
                </>
              )}
            </div>
          </AndOrDecorator>
        </div>
      </div>
    );
  }
}

UnwrappedQueryGroup.contextType = SearchContext;

UnwrappedQueryGroup.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  node: PropTypes.object,
  insertInto: PropTypes.func,
  updateNode: PropTypes.func,
  removeNode: PropTypes.func,
  canAddGroup: PropTypes.bool,
  onChange: PropTypes.func,
  search: PropTypes.object,
};

export default withStyles(styles)(UnwrappedQueryGroup);
